import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '@/integrations/supabase/client';

export const useUserLanguage = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const loadUserLanguage = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (session?.user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('locale')
          .eq('id', session.user.id)
          .single();
        
        if (profile?.locale && profile.locale !== i18n.language) {
          i18n.changeLanguage(profile.locale);
        }
      }
    };

    loadUserLanguage();
  }, [i18n]);
};
